import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-session-expired',
    templateUrl: './session-expired.component.html',
    styleUrls: ['./session-expired.component.scss'],
    standalone: false
})
export class SessionExpiredComponent implements OnInit, OnDestroy {

    countdown: number;

    private intervalId: number;
    readonly data = inject<{ title: string; messageString: string; duration: number }>(MAT_DIALOG_DATA);

    ngOnInit(): void {
        this.countdown = Math.round(this.data.duration / 1000);

        this.intervalId = window.setInterval(() => {
            this.countdown--;

            if (this.countdown <= 0) {
                window.clearInterval(this.intervalId);
            }
        }, 1000);
    }

    ngOnDestroy(): void {
        window.clearInterval(this.intervalId);
    }
}
